// Generated by purs version 0.15.10
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Filterable from "../Data.Filterable/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as MST_Data_Units from "../MST.Data.Units/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var StartIsSymbol = {
    reflectSymbol: function () {
        return "Start";
    }
};
var ResponseStartIsSymbol = {
    reflectSymbol: function () {
        return "ResponseStart";
    }
};
var LoadedBytesIsSymbol = {
    reflectSymbol: function () {
        return "LoadedBytes";
    }
};
var ResponseEndIsSymbol = {
    reflectSymbol: function () {
        return "ResponseEnd";
    }
};
var FailIsSymbol = {
    reflectSymbol: function () {
        return "Fail";
    }
};
var AbortIsSymbol = {
    reflectSymbol: function () {
        return "Abort";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var receivedTransportByteCountIsSymbol = {
    reflectSymbol: function () {
        return "receivedTransportByteCount";
    }
};
var receivedTransportDuplicateByteCountIsSymbol = {
    reflectSymbol: function () {
        return "receivedTransportDuplicateByteCount";
    }
};
var receivedTransportOutOfOrderByteCountIsSymbol = {
    reflectSymbol: function () {
        return "receivedTransportOutOfOrderByteCount";
    }
};
var retransmittedTransportByteCountIsSymbol = {
    reflectSymbol: function () {
        return "retransmittedTransportByteCount";
    }
};
var sentTransportByteCountIsSymbol = {
    reflectSymbol: function () {
        return "sentTransportByteCount";
    }
};
var transportMinimumRTTIsSymbol = {
    reflectSymbol: function () {
        return "transportMinimumRTT";
    }
};
var transportRTTVarianceIsSymbol = {
    reflectSymbol: function () {
        return "transportRTTVariance";
    }
};
var transportSmoothedRTTIsSymbol = {
    reflectSymbol: function () {
        return "transportSmoothedRTT";
    }
};
var TransmissionStatsIsSymbol = {
    reflectSymbol: function () {
        return "TransmissionStats";
    }
};
var payloadIsSymbol = {
    reflectSymbol: function () {
        return "payload";
    }
};
var timestampIsSymbol = {
    reflectSymbol: function () {
        return "timestamp";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Bytes.eqBytes);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Duration.eqDuration);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Bytes.encodeJsonBytes);
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Duration.encodeJsonDuration);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Bytes.decodeJsonBytes));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Duration.decodeJsonDuration));
var arbitraryConstructor = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(Test_QuickCheck_Arbitrary.arbitraryNoArguments);
var arbGenSumSum = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(arbitraryConstructor);
var arbitraryRecordInstance = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRecordInstance();
var arbitraryRowListCons = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(Fusion_Data_Bytes.arbitraryBytes);
var arbitraryRowListCons1 = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(Fusion_Data_Duration.arbitraryDuration);
var pure = /* #__PURE__ */ Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen);
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(MST_Data_Units.ordStreamId)(Data_Foldable.foldableArray);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Fusion_Data_Bytes.monoidBytes);
var filterMap = /* #__PURE__ */ Data_Filterable.filterMap(Data_Filterable.filterableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var join = /* #__PURE__ */ Control_Bind.join(Control_Bind.bindArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var filter = /* #__PURE__ */ Data_Filterable.filter(Data_Filterable.filterableArray);
var Start = /* #__PURE__ */ (function () {
    function Start() {

    };
    Start.value = new Start();
    return Start;
})();
var ResponseStart = /* #__PURE__ */ (function () {
    function ResponseStart() {

    };
    ResponseStart.value = new ResponseStart();
    return ResponseStart;
})();
var LoadedBytes = /* #__PURE__ */ (function () {
    function LoadedBytes(value0) {
        this.value0 = value0;
    };
    LoadedBytes.create = function (value0) {
        return new LoadedBytes(value0);
    };
    return LoadedBytes;
})();
var ResponseEnd = /* #__PURE__ */ (function () {
    function ResponseEnd() {

    };
    ResponseEnd.value = new ResponseEnd();
    return ResponseEnd;
})();
var Fail = /* #__PURE__ */ (function () {
    function Fail(value0) {
        this.value0 = value0;
    };
    Fail.create = function (value0) {
        return new Fail(value0);
    };
    return Fail;
})();
var Abort = /* #__PURE__ */ (function () {
    function Abort() {

    };
    Abort.value = new Abort();
    return Abort;
})();
var TransmissionStats = /* #__PURE__ */ (function () {
    function TransmissionStats(value0) {
        this.value0 = value0;
    };
    TransmissionStats.create = function (value0) {
        return new TransmissionStats(value0);
    };
    return TransmissionStats;
})();
var StreamEventBatch = function (x) {
    return x;
};
var semigroupStreamEventBatch = /* #__PURE__ */ Data_Map_Internal.semigroupMap()(MST_Data_Units.ordStreamId)(Data_Semigroup.semigroupArray);
var monoidStreamEventBatch = /* #__PURE__ */ Data_Map_Internal.monoidSemigroupMap()(MST_Data_Units.ordStreamId)(Data_Semigroup.semigroupArray);
var isFinalStreamEventPayload = {
    isFinal: function (v) {
        if (v instanceof Start) {
            return false;
        };
        if (v instanceof ResponseStart) {
            return false;
        };
        if (v instanceof LoadedBytes) {
            return false;
        };
        if (v instanceof ResponseEnd) {
            return true;
        };
        if (v instanceof Fail) {
            return true;
        };
        if (v instanceof Abort) {
            return true;
        };
        if (v instanceof TransmissionStats) {
            return false;
        };
        throw new Error("Failed pattern match at MST.Data.StreamEvent (line 131, column 13 - line 138, column 33): " + [ v.constructor.name ]);
    }
};
var genericStreamEventPayload = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Start.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ResponseStart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new LoadedBytes(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return ResponseEnd.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new Fail(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return Abort.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return new TransmissionStats(x.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at MST.Data.StreamEvent (line 110, column 1 - line 110, column 45): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Start) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ResponseStart) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof LoadedBytes) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof ResponseEnd) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Fail) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof Abort) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof TransmissionStats) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
        };
        throw new Error("Failed pattern match at MST.Data.StreamEvent (line 110, column 1 - line 110, column 45): " + [ x.constructor.name ]);
    }
};
var showStreamEventPayload = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreamEventPayload)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(StartIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ResponseStartIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Fusion_Data_Bytes.showBytes))(LoadedBytesIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ResponseEndIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(FailIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(AbortIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(receivedTransportByteCountIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(receivedTransportDuplicateByteCountIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(receivedTransportOutOfOrderByteCountIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(retransmittedTransportByteCountIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(sentTransportByteCountIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(transportMinimumRTTIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(transportRTTVarianceIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(transportSmoothedRTTIsSymbol)(Fusion_Data_Duration.showDuration))(Fusion_Data_Duration.showDuration))(Fusion_Data_Duration.showDuration))(Fusion_Data_Bytes.showBytes))(Fusion_Data_Bytes.showBytes))(Fusion_Data_Bytes.showBytes))(Fusion_Data_Bytes.showBytes))(Fusion_Data_Bytes.showBytes))))(TransmissionStatsIsSymbol))))))))
};
var genericStreamEventBatch_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showStreamEventBatch = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreamEventBatch_)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Map_Internal.showMap(MST_Data_Units.showStreamId)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(payloadIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(timestampIsSymbol)(Fusion_Data_Timestamp.showTimestamp))(showStreamEventPayload))))))({
        reflectSymbol: function () {
            return "StreamEventBatch";
        }
    }))
};
var eqStreamEventPayload = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Start && y instanceof Start) {
                return true;
            };
            if (x instanceof ResponseStart && y instanceof ResponseStart) {
                return true;
            };
            if (x instanceof LoadedBytes && y instanceof LoadedBytes) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof ResponseEnd && y instanceof ResponseEnd) {
                return true;
            };
            if (x instanceof Fail && y instanceof Fail) {
                return x.value0 === y.value0;
            };
            if (x instanceof Abort && y instanceof Abort) {
                return true;
            };
            if (x instanceof TransmissionStats && y instanceof TransmissionStats) {
                return eq(x.value0.receivedTransportByteCount)(y.value0.receivedTransportByteCount) && eq(x.value0.receivedTransportDuplicateByteCount)(y.value0.receivedTransportDuplicateByteCount) && eq(x.value0.receivedTransportOutOfOrderByteCount)(y.value0.receivedTransportOutOfOrderByteCount) && eq(x.value0.retransmittedTransportByteCount)(y.value0.retransmittedTransportByteCount) && eq(x.value0.sentTransportByteCount)(y.value0.sentTransportByteCount) && eq2(x.value0.transportMinimumRTT)(y.value0.transportMinimumRTT) && eq2(x.value0.transportRTTVariance)(y.value0.transportRTTVariance) && eq2(x.value0.transportSmoothedRTT)(y.value0.transportSmoothedRTT);
            };
            return false;
        };
    }
};
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Map_Internal.eqMap(MST_Data_Units.eqStreamId)(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(timestampIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))()(payloadIsSymbol)(eqStreamEventPayload)))));
var eq4 = /* #__PURE__ */ Data_Eq.eq(eqStreamEventPayload);
var eqStreamEventBatch = {
    eq: function (x) {
        return function (y) {
            return eq3(x)(y);
        };
    }
};
var encodeJsonStreamEventPayl = {
    encodeJson: /* #__PURE__ */ MST_Encoding["genericEncodeJsonVisonum$prime"](genericStreamEventPayload)("kind")(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ResponseStartIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(LoadedBytesIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Fusion_Data_Bytes.encodeJsonBytes)))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ResponseEndIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(FailIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString)))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(AbortIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(TransmissionStatsIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(Data_Argonaut_Encode_Class.gEncodeJsonNil)(transportSmoothedRTTIsSymbol)())(transportRTTVarianceIsSymbol)())(transportMinimumRTTIsSymbol)())(sentTransportByteCountIsSymbol)())(retransmittedTransportByteCountIsSymbol)())(receivedTransportOutOfOrderByteCountIsSymbol)())(receivedTransportDuplicateByteCountIsSymbol)())(receivedTransportByteCountIsSymbol)())())))))))))
};
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ MST_Encoding.encodeJsonEncDecWrapMap(MST_Data_Units.encodeJsonStreamId)(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonStreamEventPayl)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Timestamp.encodeJsonTimestamp)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(timestampIsSymbol)())(payloadIsSymbol)())())));
var encodeJsonStreamEventBatc = {
    encodeJson: function (v) {
        return encodeJson(v);
    }
};
var decodeJsonStreamEventPayl = {
    decodeJson: /* #__PURE__ */ MST_Encoding["genericDecodeJsonVisonum$prime"](genericStreamEventPayload)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(StartIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(ResponseStartIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(LoadedBytesIsSymbol)(Fusion_Data_Bytes.decodeJsonBytes))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(ResponseEndIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(FailIsSymbol)(Data_Argonaut_Decode_Class.decodeJsonString))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(AbortIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(TransmissionStatsIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil)(transportSmoothedRTTIsSymbol)()())(transportRTTVarianceIsSymbol)()())(transportMinimumRTTIsSymbol)()())(sentTransportByteCountIsSymbol)()())(retransmittedTransportByteCountIsSymbol)()())(receivedTransportOutOfOrderByteCountIsSymbol)()())(receivedTransportDuplicateByteCountIsSymbol)()())(receivedTransportByteCountIsSymbol)()())()))))))))("kind")
};
var decodeJsonStreamEventBatc = {
    decodeJson: /* #__PURE__ */ (function () {
        var $457 = Data_Functor.map(Data_Either.functorEither)((function () {
            var $460 = Data_Newtype.unwrap();
            return function ($461) {
                return StreamEventBatch($460($461));
            };
        })());
        var $458 = Data_Argonaut_Decode_Class.decodeJson(MST_Encoding.decodeJsonEncDecWrapMap(Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_Units.decodeJsonStreamId))(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonStreamEventPayl))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Timestamp.decodeJsonTimestamp))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(timestampIsSymbol)()())(payloadIsSymbol)()())())))(MST_Data_Units.ordStreamId));
        return function ($459) {
            return $457($458($459));
        };
    })()
};
var arbitraryStreamEventPaylo = {
    arbitrary: /* #__PURE__ */ Test_QuickCheck_Arbitrary.genericArbitrary(genericStreamEventPayload)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrarySum(arbitraryConstructor)(/* #__PURE__ */ arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(Fusion_Data_Bytes.arbitraryBytes)))(/* #__PURE__ */ arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(Test_QuickCheck_Arbitrary.arbString)))(/* #__PURE__ */ arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(/* #__PURE__ */ arbitraryRecordInstance(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons1(/* #__PURE__ */ arbitraryRowListCons1(/* #__PURE__ */ arbitraryRowListCons1(Test_QuickCheck_Arbitrary.arbitraryRowListNil)()()()(transportSmoothedRTTIsSymbol))()()()(transportRTTVarianceIsSymbol))()()()(transportMinimumRTTIsSymbol))()()()(sentTransportByteCountIsSymbol))()()()(retransmittedTransportByteCountIsSymbol))()()()(receivedTransportOutOfOrderByteCountIsSymbol))()()()(receivedTransportDuplicateByteCountIsSymbol))()()()(receivedTransportByteCountIsSymbol)))))))))))
};
var arbitraryStreamEventBatch = {
    arbitrary: /* #__PURE__ */ Control_Bind.bind(Test_QuickCheck_Gen.bindGen)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrary(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbArray(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbTuple(MST_Data_Units.arbitraryStreamId)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbArray(/* #__PURE__ */ arbitraryRecordInstance(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(arbitraryStreamEventPaylo)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(Fusion_Data_Timestamp.arbitraryTimestamp)(Test_QuickCheck_Arbitrary.arbitraryRowListNil)()()()(timestampIsSymbol))()()()(payloadIsSymbol)))))))(function (v) {
        return pure(fromFoldable(v));
    })
};
var countBytes = function (v) {
    return fold(filterMap(function (v1) {
        if (v1 instanceof LoadedBytes) {
            return new Data_Maybe.Just(v1.value0);
        };
        return Data_Maybe.Nothing.value;
    })(map(function (v1) {
        return v1.payload;
    })(join(map(Data_Tuple.snd)(toUnfoldable(v))))));
};
var countAborts = function (v) {
    return Data_Array.length(filter(function (v1) {
        return eq4(v1)(Abort.value);
    })(map(function (v1) {
        return v1.payload;
    })(join(map(Data_Tuple.snd)(toUnfoldable(v))))));
};
export {
    StreamEventBatch,
    Start,
    ResponseStart,
    LoadedBytes,
    ResponseEnd,
    Fail,
    Abort,
    TransmissionStats,
    countAborts,
    countBytes,
    decodeJsonStreamEventBatc,
    encodeJsonStreamEventBatc,
    decodeJsonStreamEventPayl,
    encodeJsonStreamEventPayl,
    eqStreamEventPayload,
    eqStreamEventBatch,
    genericStreamEventPayload,
    genericStreamEventBatch_,
    showStreamEventPayload,
    showStreamEventBatch,
    arbitraryStreamEventPaylo,
    arbitraryStreamEventBatch,
    semigroupStreamEventBatch,
    monoidStreamEventBatch,
    isFinalStreamEventPayload
};
